import { useCallback } from 'react';
import { useRouter } from 'next/router';
import stopEvent from '@tmap/mmm-style-guide/src/util/stopEvent';
import useLazySSR from '@tmap/mmm-style-guide/src/ssr/useLazySSR';
import { getRandomEntry } from '../../../lib/helpers';

function useQuickApply(community) {
  const randomOfferUrl = useLazySSR((ssr) => {
    // Do not randomize the offer URL in SSR
    if (ssr) return '';
    const randomOffer = getRandomEntry(community.offers);
    if (!randomOffer) return '';
    return `/get-paid/${encodeURIComponent(randomOffer.slug.current)}`;
  }, [community.offers]);

  const router = useRouter();
  const handleQuickApply = useCallback((e) => {
    stopEvent(e);
    // Since this is a link card, prevent normal link from opening and hit this one instead
    router.push(randomOfferUrl);
  }, [randomOfferUrl, router]);

  return {
    handleQuickApply,
    hasQuickApply: Boolean(randomOfferUrl),
  };
}

export default useQuickApply;
